export class MediasApiUrls {

    //* PDF DOCUMENTS
    public static DOCUMENT_UPLOAD = '/api/v1/media/documents';
    public static DOCUMENT_UPLOAD_FROM_URL = '/api/v1/media/documents/url';
    public static DOCUMENT_URL = (docId: string) => `/api/v1/media/documents/${docId}`;

    //* IMAGES

    public static IMAGE = (imageId: string) => `/api/v1/media/images/${imageId}`;
    public static IMAGE_UPLOAD = '/api/v1/media/images';
    public static IMAGE_UPLOAD_FROM_URL = '/api/v1/media/images/url';

    //* VIDEOS
    public static VIDEO_UPLOAD = '/api-admin/v1/videos/uploads'; //* should be in VIDEO MODULE SERVICE
    public static VIDEO_URL = (videoId: string) => `/api/v1/media/videos/${videoId}`;
}